import React from "react";
import style from "./QuoteHardwareItems.module.css";
import HardwareMain from "./HardwareMain";
import PerUnitOptions from "./PerUnitOptions";

export default function QuoteHardwareItems(props) {
  return props.hardwareItems.map(item => (
    <div className={style.root} key={item.key}>
      <HardwareMain item={item} />
      <PerUnitOptions item={item} />
    </div>
  ));
}
